var jQuery = require("jquery");
require("jquery.easing");

window.jQuery = jQuery;
window.$ = jQuery;

require("moment");
require("bootstrap");
// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
// require('bootstrap/js/dist/util');
// require('bootstrap/js/dist/collapse');
// require('bootstrap/js/dist/dropdown');
// require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
// require("bootstrap/js/dist/tab");
// require('bootstrap/js/dist/tooltip');

require("bootstrap-select");
// require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');
// require('bootstrap-material-design');

require("jquery.placeholder");
// require("jquery-sticky");

// require("owl.carousel");
// require("magnific-popup");
// require('lazysizes');
// require('picturefill');

// require('@fortawesome/fontawesome-free');

// var elements = document.querySelectorAll('input,select,textarea');

// for (var i = elements.length; i--;) {
//     elements[i].addEventListener('invalid', function () {
//         this.scrollIntoView(false);
//     });
// }

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {
  // offSetContent();

  // HTML5 validation scroll offset fixed header
  // var delay = 0;
  // var offset = 150;

  // document.addEventListener('invalid', function(e){
  //    $(e.target).addClass("invalid");
  //    $('html, body').animate({scrollTop: $($(".invalid")[0]).offset().top - offset }, delay);
  // }, true);
  // document.addEventListener('change', function(e){
  //    $(e.target).removeClass("invalid")
  // }, true);

  // $('.nav-link').button('dispose')
  // Initialise the Ajax funxctions - put most of your js calls in this function
  // or if you need to reload them after an ajax call
  // initAjaxJS();

  // $(window).load(function() {
  // });

  // Universal Analytics event tracking
  if (typeof ga !== "undefined") {
    // track all phone number click events
    $('a[href^="tel:"]').on("click", function(e) {
      var href = $(this).attr("href");
      var value = href.split(":");

      // console.log('clicked', $(this).text(), value[1]);
      ga("send", "event", "Phone", "click", value[1]);
    });

    // track all email click events
    $('a[href^="mailto:"]').on("click", function(e) {
      var href = $(this).attr("href");
      var value = href.split(":");

      // console.log('clicked', $(this).text(), value[1]);
      ga("send", "event", "Email", "click", value[1]);
    });
  }

  $(".selectpicker").selectpicker();

  // $('.datepicker').datetimepicker({
  //     format: 'DD/MM/YYYY',
  //     showTodayButton: true,
  //     showClear: true
  // });

  // $('#login-modal').on('shown.bs.modal', function() {
  //     $('#email').trigger('focus')
  // })

  // placeholder polyfill for browsers that need it
  // $('input, textarea').placeholder();

  // Off canvas mobile nav
  $('[data-toggle="offcanvas"]').click(function() {
    $(".offcanvas").toggleClass("active");
    $(this).toggleClass("active");
    if($(this).hasClass('active')){
        $(this).find('.icon').text('close');
    }else{
        $(this).find('.icon').text('menu');
    }
  });

  // $('select[data-toggle="tabOption"]').on('change', function (e) {
  //     e.preventDefault();
  //     let target = e.target.value;
  //     target = $('#' + target);
  //     target.addClass('active');
  //     target.siblings().removeClass('active');
  // })

  // $("#mob-links.mob-header-links").sticky({topSpacing:0});
  // $("#main-nav.navbar").sticky({topSpacing:0});
  // $("#sticky-wrapper").sticky({topSpacing:54});

  /*if ($('#carousel-about').length) {
        $('#carousel-about').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 8,
            responsiveClass: true,
            items: 1,
            nav: false,

            // navText : ["Prev","Next"],
            center: true,
            loop: false,
            dots: true,
            dotsEach: true,
            autoplay: false,
            autoplayTimeout: 5000,
            smartSpeed: 750,
            responsive: {

                0: {

                },

                576: {

                },
                768: {
                    dots: true,
                    items: 2
                },
                1200: {
                    dots: false,
                    nav: true,
                    items: 3
                },

            }

        })
    }*/



  if ($(".page-scroll").length) {
    // Page scroll
    $(".page-scroll").bind("click", function(event) {
      var $anchor = $(this);

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $($anchor.attr("href")).offset().top
          },
          750,
          "easeInOutExpo"
        );

      event.preventDefault();
    });
  }

  scrollToFormError();

  $(window).scroll(function() {
    if ($(this).scrollTop() > 125) {
      $("#main-nav").addClass("page-down");
    } else {
      $("#main-nav").removeClass("page-down");
    }
  });


});

// scroll window to form error element and offset fixed header height
function scrollToFormError() {
  // console.log('scrollToFormError', window.location.hash);
  var windowWidth = $(window).width();
  var formStr = "#form-";
  // enquiry form error anchor offset
  if (window.location.hash && window.location.hash.indexOf(formStr) != -1) {
    var formEl = window.location.hash;
    if ($(formEl).length > 0) {
      // var offsetSize = $('.headerfixed').height();
      // console.log(window.location.hash+' '+offsetSize +' '+$(formEl).scrollTop());

      var offsetSize = $("#main-nav").height() + 50;
      if (windowWidth > 767) {
        // offset
        // animate scrollto
        $("html, body").animate(
          { scrollTop: $(formEl).offset().top - offsetSize },
          1000
        );
      } else {
        $("html, body").animate(
          { scrollTop: $(formEl).offset().top - offsetSize },
          1000
        );
      }
    }
  }
}

function offSetContent() {
  // offset about section from top of browser
  var headerHeight = $("#header").outerHeight();
  var fullHeight = $(window).height() - headerHeight;
}

function inViewport(element) {
  // Get the elements position relative to the viewport

  var bb = element.getBoundingClientRect();

  // Check if the element is outside the viewport
  // Then invert the returned value because you want to know the opposite

  return !(bb.top > innerHeight || bb.bottom < 0);
}

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {
  // Infinite Ajax Scroll
}